import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userData: null, // userData object on successful login
  token: null, // JWT token
  isAuthenticated: false, // Indicates login state
  loading: false, // Indicates if the login request is in progress
  error: null, // Holds error message on failed login
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.isAuthenticated = true;
      state.userData = action.payload.userData;
      state.token = action.payload.token;
    },
    loginFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.userData = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      state.loading = false;
    },
    updateShowSuggestionModal(state, action) {
      if (state.userData) {
        state.userData.showSuggestionModal = action.payload;
      }
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, updateShowSuggestionModal } =
  authSlice.actions;

export default authSlice.reducer;
